<template>
  <div>
    <authorized-layout>
      <ui-heading back>
        Workspace Stats
      </ui-heading>

      <div v-if="loading" class="mt-32 mb-32">
        <ui-loader />
      </div>

      <div v-else>

        <ui-page-section-box>
          <div class="flex">
            <div class="w-40">Date from:</div>
            <ui-form-input
              v-model:value="date_from"
              id="date_from"
              :required="true"
              class="inline"
            ></ui-form-input>
          </div>
          <div class="flex mt-4">
            <div class="w-40">Date to:</div>
            <ui-form-input
              v-model:value="date_to"
              id="date_to"
              :required="true"
              class="inline"
            ></ui-form-input>
          </div>

          <div class="mt-4">
            <ui-button
              color="primary"
              @click="init()"
            >
              Update
            </ui-button>
          </div>
        </ui-page-section-box>

        <ui-page-section-box class="mt-4">
          <div class="flex">
            <div class="basis-1/3">Date from:</div>
            <div>{{ $filters.dateFormat(stats.date_from) }}</div>
          </div>

          <div class="flex">
            <div class="basis-1/3">Date to:</div>
            <div>{{ $filters.dateFormat(stats.date_to) }}</div>
          </div>

          <hr class="my-4" />

          <div class="flex">
            <div class="basis-1/3">Printjobs count:</div>
            <div>{{ stats.printjobs_count }}</div>
          </div>

          <div class="flex">
            <div class="basis-1/3">Printjobs with deleted file count:</div>
            <div>{{ stats.printjobs_with_deleted_file_count }}</div>
          </div>

          <div class="flex">
            <div class="basis-1/3">Printjobs with existing file count:</div>
            <div>{{ stats.printjobs_with_existing_file_count }}</div>
          </div>

          <div class="flex">
            <div class="basis-1/3">Total filament used in g:</div>
            <div>{{ stats.total_filament_used_g }}</div>
          </div>

          <div class="flex">
            <div class="basis-1/3">Total filament used in mm:</div>
            <div>{{ stats.total_filament_used_mm }}</div>
          </div>

          <div class="flex">
            <div class="basis-1/3">Total print time in sec:</div>
            <div>{{ stats.total_printing_time_sec }}</div>
          </div>
        </ui-page-section-box>

      </div>

    </authorized-layout>
  </div>
</template>

<script>
import AuthorizedLayout from '@/components/layouts/AuthorizedLayout.vue';
import uiHeading from '@/components/ui/uiHeading.vue';
import uiPageSectionBox from '@/components/ui/uiPageSectionBox.vue';
import uiFormInput from '@/components/ui/uiFormInput.vue';
import uiButton from '@/components/ui/uiButton.vue';
import uiLoader from '@/components/ui/uiLoader.vue';

import moment from 'moment';

export default {
  name: 'WorkspaceStats',

  components: {
    AuthorizedLayout,
    uiHeading,
    uiPageSectionBox,
    uiFormInput,
    uiButton,
    uiLoader
  },

  data: () => ({
    loading: true,
    stats: {},
    date_from: moment().subtract(1, 'year').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD')
  }),

  created: async function() {
    this.init();
  },

  methods: {
    async init() {
      this.loading = true;
      await this.$store.dispatch('account/loadWorkspaceStats', { date_from: this.date_from, date_to: this.date_to });
      this.stats = this.$store.getters['account/workspaceStats'];
      this.date_from = moment(this.stats.date_from).format('YYYY-MM-DD');
      this.date_to = moment(this.stats.date_to).format('YYYY-MM-DD');
      this.loading = false;
    }
  }
}
</script>
